export enum Roles {
  ADMIN = 'ROLE_ADMIN',
  EMPLOYEE = 'ROLE_EMPLOYEE',
  COMPANY_GROUP_CURATOR = 'ROLE_COMPANY_GROUP_CURATOR',
  COMPANY_CURATOR = 'ROLE_COMPANY_CURATOR',
  FILIAL_CURATOR = 'ROLE_COMPANY_BRANCH_CURATOR',
  DIVISION_CURATOR = 'ROLE_COMPANY_BRANCH_SUBDIVISION_CURATOR',
}
